export const upsellingHc = {
  servicios: {
    accommodation: "مكان الإقامة",
    all: "الكل",
    state: "الحالة",
    search: "بحث",
    searchPlaceholder: "اسم النزيل أو رمز الحجز…",
    from: "من",
    to: "إلى",
    today: "اليوم",
    noDate: "بدون تاريخ",
    clear: "مسح",
    thService: "الخدمة",
    thGuest: "النزيل",
    thBooking: "الحجز",
    thRequested: "تاريخ الطلب",
    statusConsult: "عند الطلب",
    statusRejected: "مرفوض",
    statusPaid: "مدفوع",
    statusPartial: "دفع جزئي",
    statusApproved: "معتمد",
    statusPending: "قيد الانتظار",
    serviceFallback: "الخدمة",
    openBookingTitle: "فتح الحجز",
    approve: "اعتماد",
    reject: "رفض",
    viewBooking: "عرض الحجز",
    noRecords: "لا توجد سجلات",
    noRecordsFiltered: "لم يتم العثور على سجلات بالمرشحات المطبَّقة.",
    noRequestsYet: "بمجرد أن يطلب أحد النزلاء خدمة ستظهر هنا.",
    chipBreakfast: "إفطار",
    chipTour: "جولة",
    chipTransport: "نقل",
    chipMore: "وكل ما تقدمه",
    approveTitle: "اعتماد الطلب",
    amountLabel: "المبلغ المطلوب تحصيله",
    amountFree: "0 = بدون رسوم",
    amountHint: "عند ربط بوابة دفع، يُرسَل إلى النزيل <strong>رابط دفع</strong> (WhatsApp + البريد الإلكتروني). وإن لم تكن مربوطة، يُبلَّغ بأنه <strong>سيدفع عند الوصول</strong>.",
    cancel: "إلغاء",
    processing: "جارٍ المعالجة…",
    approveAndNotify: "اعتماد وإبلاغ",
    amountInvalid: "أدخل مبلغًا صالحًا (0 = بدون رسوم).",
    approvedPaymentLink: "تم الاعتماد. تم إرسال رابط الدفع إلى النزيل (WhatsApp + البريد الإلكتروني).",
    approvedOnArrival: "تم الاعتماد. سيدفع النزيل عند الوصول (لا توجد بوابة مربوطة).",
    approvedNotified: "تم الاعتماد. تم إبلاغ النزيل.",
    approveFailed: "تعذَّر اعتماد الطلب.",
    rejectTitle: "رفض الطلب",
    rejectMessage: "عند رفضه، لن يُحصَّل من النزيل مقابل هذه الخدمة وسيتم إبلاغه. هل تريد رفض الطلب؟",
    rejected: "تم رفض الطلب. تم إبلاغ النزيل.",
    rejectFailed: "تعذَّر رفض الطلب.",
  },
  form: {
    basicTitle: "المعلومات الأساسية",
    basicDesc: "الاسم والوصف اللذان سيراهما النزيل.",
    autoTranslate: "اكتبه <strong>بلغتك</strong>. عند الحفظ يُترجَم <strong>تلقائيًا</strong> إلى جميع اللغات (الإسبانية والإنجليزية والبرتغالية والفرنسية والألمانية والإيطالية والصينية والعربية)؛ وسيرى النزيل لغته.",
    selectPlaceholder: "اختر…",
    catNightlife: "الحياة الليلية",
    subtitleLabel: "عنوان فرعي",
    optional: "اختياري",
    subtitlePlaceholder: "عبارة جذّابة قصيرة، مثال: “عِش التجربة”",
    price: "السعر",
    priceDesc: "كيف تُحصَّل قيمة هذه الخدمة من النزيل.",
    segWithPrice: "بسعر محدد",
    segWithPriceDesc: "يُحصَّل تلقائيًا",
    segOnRequest: "عند الطلب",
    segOnRequestDesc: "يسأل النزيل وأنت تحدّد السعر",
    currencyLabel: "العملة",
    currencyHint: "عملة الإعلان",
    chargeBy: "طريقة التحصيل",
    unitPlaceholder: "اختر الطريقة…",
    unitPerUnit: "لكل وحدة (سعر ثابت)",
    unitPerPerson: "لكل شخص (× النزلاء)",
    unitPerNight: "لكل ليلة (× الليالي)",
    unitPerGroup: "لكل مجموعة / إقامة",
    unitPerHour: "لكل ساعة",
    unitHintPerson: "سيُضرب في عدد النزلاء في الحجز.",
    unitHintNight: "سيُضرب في عدد الليالي في الحجز.",
    unitHintUnit: "سعر ثابت لكل وحدة يشتريها النزيل.",
    unitHintGroup: "سعر واحد للحجز، بغض النظر عن عدد الأشخاص أو الليالي.",
    unitHintHour: "السعر لكل ساعة محجوزة.",
    unitLabelPerson: "/ لكل شخص",
    unitLabelNight: "/ لكل ليلة",
    unitLabelGroup: "/ لكل إقامة",
    unitLabelHour: "/ لكل ساعة",
    stockControl: "التحكم في المخزون",
    inventory: "المخزون",
    stockDesc: "لما ينفد (مثل سرير أو سرير أطفال إضافي): حدِّد عدد الوحدات. تُخصَم تلقائيًا مع كل حجز وفي الوقت الفعلي.",
    unitsAvailable: "الوحدات المتاحة",
    removeUnitAria: "إزالة وحدة",
    addUnitAria: "إضافة وحدة",
    stockNoteSoldOut: "عند <strong>0</strong> وحدة تظهر الخدمة <strong>نفد</strong> ولا يمكن إضافتها.",
    stockNoteAuto: "عند الوصول إلى 0 ستظهر <strong>نفد</strong> تلقائيًا.",
    stockConsumePerson: "كل حجز يخصم وحدة واحدة لكل نزيل.",
    stockConsumeNight: "كل حجز يخصم وحدة واحدة لكل ليلة.",
    stockModeTitle: "كيف يعمل المخزون",
    stockModeAvail: "حسب التوفّر",
    stockModeAvailDesc: "يُشغَل فقط أثناء الإقامة ويُحرَّر عند تسجيل المغادرة (سرير أطفال، سرير إضافي).",
    stockModeProduct: "حسب المنتج",
    stockModeProductDesc: "يُخصَم مع كل حجز ولا يعود. تعيد تعبئته يدويًا.",
    stockUnlimited: "مخزون غير محدود — بلا حد للوحدات.",
    photosTitle: "الصور",
    photoMain: "رئيسية",
    makeMainTitle: "جعلها رئيسية",
    removeTitle: "إزالة",
    addPhoto: "إضافة صورة",
    addPhotos: "إضافة صور",
    reorderHint: "اسحب لإعادة الترتيب · الأولى هي التي تظهر في البطاقة.",
    whereTitle: "أين تُقدَّم؟",
    whereDesc: "الإعلانات التي ستتوفر فيها. بدون تحديد = الكل.",
    selected: "{count} محدد",
    all: "الكل",
    none: "لا شيء",
    searchListingPlaceholder: "ابحث عن إعلان…",
    noResults: "لا توجد نتائج",
    diffCurrencyTitle: "هذا الإعلان يستخدم {currency}. تكون الخدمة بعملة واحدة فقط.",
    unit: "وحدة",
    units: "وحدات",
    loadingListings: "جارٍ تحميل الإعلانات…",
    previewLabel: "معاينة · هكذا سيراها النزيل",
    previewPhoto: "صورتك الرئيسية",
    previewTitleFallback: "اسم الخدمة",
    previewDescFallback: "سيظهر هنا الوصف الذي تكتبه ليعرف النزيل ما الذي تتضمنه.",
    free: "مجاني",
    soldOut: "نفد",
    add: "إضافة",
    remaining: "تبقّت {count} وحدة | تبقّت {count} وحدات",
    scopeManaged: "تُقدَّم في <strong>جميع إعلاناتك</strong>. اختر أيها من قائمة الخدمات والتجارب.",
    scopeAll: "متاح في <strong>جميع أماكن إقامتك</strong>",
    scopeSome: "متاح في <strong>{count}</strong> إعلان | متاح في <strong>{count}</strong> إعلانات",
    errNameRequired: "الاسم مطلوب",
    errCategoryRequired: "الفئة مطلوبة",
    errDescRequired: "الوصف مطلوب",
    errPriceRequired: "أدخل سعرًا (ضع 0 إذا كان مجانيًا).",
    errPriceNegative: "لا يمكن أن يكون السعر سالبًا.",
    errUnitRequired: "اختر طريقة التحصيل (طريقة التحصيل)",
    errStockRequired: "حدِّد عدد الوحدات المتوفرة في المخزون (ضع 0 إذا نفد).",
    errProcessing: "خطأ أثناء معالجة الطلب.",
  },
  createServicio: {
    subtitle: "أكمل المعلومات وشاهد المعاينة في الوقت الفعلي.",
    photosDesc: "أضف ما تشاء · الأولى هي الرئيسية · JPG أو PNG أو WebP.",
    imageRequired: "حمّل صورة واحدة على الأقل.",
  },
  updateServicio: {
    title: "تعديل التجربة أو الخدمة",
    subtitle: "حدِّث المعلومات وشاهد المعاينة في الوقت الفعلي.",
    loadingAria: "جارٍ تحميل الخدمة",
    photosDesc: "أضف أو احذف ما تشاء · الأولى هي الرئيسية · JPG أو PNG أو WebP.",
    save: "حفظ التغييرات",
    imageRequired: "يجب أن تبقى صورة واحدة على الأقل.",
    loadFailed: "تعذَّر تحميل الخدمة.",
  },
  configUpselling: {
    title: "إعدادات البيع المتقاطع",
    phoneIntro: "أدخل رقم الهاتف الذي تريد استخدامه لتلقّي إشعارات طلبات الخدمة عبر WhatsApp",
    saveWhatsapp: "حفظ WhatsApp",
    editWhatsapp: "تعديل WhatsApp",
    mustEnterWhatsapp: "يجب إدخال رقم WhatsApp",
    swalTitle: "WhatsApp للبيع المتقاطع",
    swalText: "ستتلقّى جميع إشعارات الخدمات التي يطلبها العملاء",
    cancel: "إلغاء",
    addedSuccess: "تمت إضافة WhatsApp بنجاح",
  },
};
